if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"idun","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(166|222|269|604|689|82|98)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}